import Button from 'react-bootstrap/Button';
import { useNavigate } from 'react-router';

function AggregatorsActions() {
  const navigate = useNavigate();

  const onClick = () => navigate('/aggregator/new');

  return (
    <Button className="bo-button" onClick={onClick}>
      New Aggregator
    </Button>
  );
}

export default AggregatorsActions;
